import React from 'react';
import {SelectInput} from '~/components/Controls/Select';
import {useSession} from '~/modules/Profile/session';
import {useImpersonatedResourceOptions} from '~/modules/RillAnalytics/useImpersonatedResourceOptions';
import style from './index.module.scss';

export const ImpersonatedResourceSwitcher = () => {
    const {session, setSelectedImpersonatedResource} = useSession();
    const userId = session.selectedImpersonatedUserId;
    const {items, isPending} = useImpersonatedResourceOptions(userId);

    if (userId == null || isPending || items.length <= 1) return null;

    const value = session.selectedImpersonatedResourceId ?? items[0].value;

    return (
        <SelectInput
            value={value}
            items={items}
            onChange={(id) => setSelectedImpersonatedResource?.(id)}
            className={style.agencySwitcher}
            searchable
        />
    );
};
